import { h, render, Component } from 'preact';


const trending = (props) => (
	<svg id="trending" version="1.1" xmlns="http://www.w3.org/2000/svg" xlinkHref="http://www.w3.org/1999/xlink" viewBox="0 0 72 72" class={props.class}>
		<polygon points="49.6,15.6 57.4,23.4 40.8,40 27.2,26.4 2,51.6 6.8,56.4 27.2,36 40.8,49.6 62.2,28.2 70,36 70,15.6" />
	</svg>
);

export default trending;


// WEBPACK FOOTER //
// ../q-components/components/icons/searchIcons/trending/index.js